import { HasId } from '../../../../shared/basic-data-management/has-id.interface';
import { OuvrageTLR } from '../../ouvrage/entities/ouvrage-tlr.entity';

export class GroupementParc implements HasId {
	id!: number;
	code!: string;
	libelle!: string;
	antenneNom!: string;
	antenneId!: number;
	parcs!: string;
	parcIds: number[] = [];
	ouvrages: OuvrageTLR[] = [];
	
	constructor() {
	}
}